/* ---------- Gift option, delivery estimate, saved items ---------- */
(function () {
  'use strict';
  document.querySelectorAll('[data-gift-toggle]').forEach(function (t) {
    var box = t.closest('.gift');
    var msg = box ? box.querySelector('[data-gift-msg]') : null;
    var sync = function () { if (msg) msg.disabled = !t.checked; };
    t.addEventListener('change', sync);
    sync();
  });

  document.querySelectorAll('[data-eta]').forEach(function (el) {
    var min = parseInt(el.getAttribute('data-min'), 10);
    var max = parseInt(el.getAttribute('data-max'), 10);
    if (!(min > 0) || !(max >= min)) return;
    function addBusinessDays(from, n) {
      var d = new Date(from.getTime());
      while (n > 0) {
        d.setDate(d.getDate() + 1);
        var wd = d.getDay();
        if (wd !== 0 && wd !== 6) n--;
      }
      return d;
    }
    var now = new Date();
    var fmt = function (d) { return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }); };
    var out = el.querySelector('[data-eta-text]');
    if (out) out.textContent = 'Order today, estimated delivery ' + fmt(addBusinessDays(now, min)) + ' \u2013 ' + fmt(addBusinessDays(now, max)) + '.';
  });

  var KEY = 'carrow:saved';
  function read() {
    try { var l = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(l) ? l : []; } catch (e) { return []; }
  }
  function write(l) { try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) {} }
  function paintCount() {
    var n = read().length;
    document.querySelectorAll('[data-saved-count]').forEach(function (c) { c.textContent = n; c.setAttribute('data-count', n); });
  }
  paintCount();

  document.querySelectorAll('[data-save]').forEach(function (btn) {
    var h = btn.getAttribute('data-save');
    var label = btn.querySelector('[data-save-label]');
    function paint() {
      var on = read().indexOf(h) > -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.classList.toggle('is-on', on);
      if (label) label.textContent = on ? 'Saved' : 'Save for later';
    }
    btn.addEventListener('click', function () {
      var l = read();
      var i = l.indexOf(h);
      if (i > -1) l.splice(i, 1); else l.unshift(h);
      write(l.slice(0, 50));
      paint();
      paintCount();
    });
    paint();
  });

  var page = document.querySelector('[data-saved-page]');
  if (!page) return;
  var list = read();
  var ul = page.querySelector('[data-saved-list]');
  var empty = page.querySelector('[data-saved-empty]');
  if (!list.length) return;
  if (empty) empty.hidden = true;
  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  Promise.all(list.map(function (h) {
    return fetch(root + 'products/' + encodeURIComponent(h) + '?section_id=card-render')
      .then(function (r) { return r.ok ? r.text() : ''; })
      .catch(function () { return ''; });
  })).then(function (htmls) {
    var n = 0;
    htmls.forEach(function (html, i) {
      if (!html) return;
      var card = new DOMParser().parseFromString(html, 'text/html').querySelector('.card');
      if (!card) return;
      var li = document.createElement('li');
      li.appendChild(card);
      var rm = document.createElement('button');
      rm.type = 'button';
      rm.className = 'saved__remove';
      rm.textContent = 'Remove';
      rm.addEventListener('click', function () {
        var l = read();
        var k = l.indexOf(list[i]);
        if (k > -1) { l.splice(k, 1); write(l); }
        li.remove();
        paintCount();
        if (!ul.children.length && empty) empty.hidden = false;
      });
      li.appendChild(rm);
      ul.appendChild(li);
      n++;
    });
    if (!n && empty) empty.hidden = false;
  });
})();
